export const PINBOARD_ROUTE_COOKIE = 'pinboard_route_ids';
export const PINBOARD_PINNED_COOKIE = 'pinboard_pinned_ids';
export const PINBOARD_SCOPE_COOKIE = 'pinboard_scope_isos';
export const PINBOARD_SELECTED_ISO_COOKIE = 'pinboard_selected_iso';
export const PINBOARD_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

export function readCookieValue(key: string): string | null {
  const encodedKey = encodeURIComponent(key);
  const cookies = document.cookie
    ? document.cookie
      .split(';')
      .map((cookie) => cookie.trim())
      .filter((cookie) => cookie.length > 0)
    : [];
  const matchedCookie = cookies.find((cookie) => cookie.startsWith(`${encodedKey}=`));
  if (!matchedCookie) return null;

  const encodedValue = matchedCookie.slice(encodedKey.length + 1);
  return decodeURIComponent(encodedValue);
}

export function writeCookieValue(key: string, value: string): void {
  const secureSegment = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; Max-Age=${PINBOARD_COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secureSegment}`;
}

export function persistRouteCookie(nextRouteIds: number[]): void {
  writeCookieValue(PINBOARD_ROUTE_COOKIE, JSON.stringify(nextRouteIds));
}

export function persistPinnedCookie(nextPinnedIds: number[]): void {
  writeCookieValue(PINBOARD_PINNED_COOKIE, JSON.stringify(nextPinnedIds));
}

export function persistScopeCookie(nextScopeIsos: string[]): void {
  writeCookieValue(PINBOARD_SCOPE_COOKIE, JSON.stringify(nextScopeIsos));
}

export function parseNumericArrayCookie(key: string): number[] | null {
  const rawValue = readCookieValue(key);
  if (!rawValue) return null;

  try {
    const parsed = JSON.parse(rawValue);
    if (!Array.isArray(parsed)) return null;

    return [...new Set(
      parsed
        .map((value) => Number(value))
        .filter((value): value is number => Number.isFinite(value) && value !== 0),
    )];
  } catch {
    return null;
  }
}

export function parseIsoArrayCookie(key: string): string[] | null {
  const rawValue = readCookieValue(key);
  if (!rawValue) return null;

  try {
    const parsed = JSON.parse(rawValue);
    if (!Array.isArray(parsed)) return null;

    return [...new Set(
      parsed
        .map((value) => String(value || '').toUpperCase())
        .filter((value) => value.length === 2),
    )];
  } catch {
    return null;
  }
}

export function parseSingleIsoCookie(key: string): string | null {
  const rawValue = readCookieValue(key);
  if (!rawValue) return null;

  const parsedValue = String(rawValue || '').toUpperCase();
  return parsedValue.length === 2 ? parsedValue : null;
}
